import logger from '../../../utils/logger';

export const getInjector = async () => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    logger.error(
      'Error waiting for APP_EXTENSION_SDK_ANGULAR_JS_LOADED',
      error,
    );

    return undefined;
  }

  return window.angular.element(document.body)?.injector();
};
